import { render, staticRenderFns } from "./ApiSettings.vue?vue&type=template&id=4a96d44e&"
import script from "./ApiSettings.vue?vue&type=script&lang=js&"
export * from "./ApiSettings.vue?vue&type=script&lang=js&"
import style0 from "./ApiSettings.vue?vue&type=style&index=0&id=4a96d44e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports